<template>
    <div style="width:100%">

        <v-card class="mx-auto mb-4" width="100%">
            <v-card-text>
                <div class="text-h5">Remedy Details</div>
            </v-card-text>

            <div class="pa-4">

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Submit Date</v-list-item-title>
                        <v-list-item-subtitle>{{ data.submitDate | DateTime }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Request Number</v-list-item-title>
                        <v-list-item-subtitle>{{ data.requestNumber }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Severity</v-list-item-title>
                        <v-list-item-subtitle>TBC</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Status</v-list-item-title>
                        <v-list-item-subtitle>{{ data.status }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Summary</v-list-item-title>
                        <v-list-item-subtitle>TBC</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Assigned Group</v-list-item-title>
                        <v-list-item-subtitle>{{data.assignedGroup}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Assignee</v-list-item-title>
                        <v-list-item-subtitle>{{data.assignee}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Reported Date</v-list-item-title>
                        <v-list-item-subtitle>{{data.reportedDate | DateTime}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Resolved Date</v-list-item-title>
                        <v-list-item-subtitle>{{data.reportedDate | DateTime}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Site</v-list-item-title>
                        <v-list-item-subtitle>TBC</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Channel</v-list-item-title>
                        <v-list-item-subtitle>{{data.channel}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title>Resolution</v-list-item-title>
                        <v-list-item-subtitle v-html="data.resolution" class="text-wrap"></v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

            </div>


        </v-card>
    </div>
</template>

<script>

    export default {
        name: 'RemedyDetails',
        data: function () {
            return {
            }
        },
        components: {

        },
        props: {
            data: {
                default: () => { },
                type: Object
            },
        },
        computed: {
         
        },
        methods: {

        }
    }
</script>
